import { Helmet } from "react-helmet";
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { Row, Col, Modal, Typography, Button } from "antd";
import { PlusOutlined, ArrowLeftOutlined } from "@ant-design/icons";

import { useAppSelector } from "app/hooks";
import { useDownloadSettlementReportMutation } from "pages/Report/reportApiSlice";

import ErrorFallback from "components/ErrorFallback";
import { TableWrapper, ReportContainer } from "./styled";

const { Title } = Typography;

const Report: React.FC = () => {
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false);
  const [downloadSettlementReport, downloadSettlementReportResult] =
    useDownloadSettlementReportMutation();
  const { transactionReportParams } = useAppSelector((state) => state.report);

  const handleDownloadReport = () => {
    downloadSettlementReport({
      fileName: "Settlement_Report",
      ...transactionReportParams,
    });
  };

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <ReportContainer>
        <Helmet>
          <title>Report | Settlement</title>
          <meta name="description" content="Helmet application" />
        </Helmet>
        <Modal
          okText="Yes"
          title="Select Server"
          maskClosable={false}
          visible={modalVisible}
          onCancel={() => setModalVisible(false)}
        />
        <Row>
          <Col className="heading" span={24}>
            <Title level={4}>Report</Title>
          </Col>
        </Row>

        <Row justify="space-between">
          <Col>
            <Button
              size="large"
              shape="circle"
              style={{ marginTop: 15 }}
              onClick={() => navigate(-1)}
              icon={<ArrowLeftOutlined />}
            />
          </Col>

          <Col>
            <Button
              size="large"
              type="primary"
              onClick={handleDownloadReport}
              style={{ marginTop: 15, width: 130 }}
              loading={downloadSettlementReportResult.isLoading}
            >
              Download
              <PlusOutlined />
            </Button>
          </Col>
        </Row>

        <TableWrapper>
          <Outlet />
        </TableWrapper>
      </ReportContainer>
    </ErrorBoundary>
  );
};

export default Report;
